import { ModuleWithProviders, NgModule } from '@angular/core';
import { environment } from './environment';

@NgModule()
export class FeatureTogglingModule {
  public static forRoot(env): ModuleWithProviders<FeatureTogglingModule> {
    return {
      ngModule: FeatureTogglingModule,
      providers: [{ provide: environment, useValue: env }],
    };
  }
}
